
import React from 'react';
import { motion } from 'framer-motion';
import { Control } from 'react-hook-form';
import { RegistrationFormValues } from '@/schemas/registrationSchema';
import { JobInfoFields } from '@/components/registration';
import { useIsMobile } from '@/hooks/use-mobile';

interface JobInfoSectionProps {
  control: Control<RegistrationFormValues>;
}

const JobInfoSection: React.FC<JobInfoSectionProps> = ({ control }) => {
  const isMobile = useIsMobile();
  
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.4, duration: 0.5 }}
      className={`${isMobile ? 'py-3 px-2' : 'p-4'} bg-blue-50 bg-opacity-50 rounded-lg border border-blue-100`}
    >
      <JobInfoFields control={control} />
    </motion.div>
  );
};

export default JobInfoSection;
